import {fetchApi} from "@mbj-front-monorepo/data-access";
import {useQuery} from "@tanstack/react-query";

export const useGetAllDroits = () => {
    const promise = () => fetchApi("/api/droits", "get");
    return useQuery<Awaited<ReturnType<typeof promise>>, Error>(["droits"], promise);
};
